module.exports = __webpack_public_path__ + "static/media/id-popup-step5.f6cdfc50.png";